module.exports = __webpack_public_path__ + "static/media/online-student-testing-icon_2-color.0a977207.svg";